(() => {
    window.dataLayer = window.dataLayer || [];

    // SWP 483, bn card 2.0 codes
    window.checkBnCardCode = () => {
        if (!document.querySelector('#trackandtrace__searchinput')) {
            return
        }

        // check format and trigger event forfaq BN Card 2.0 cases
        const bnCardRegex = /^[A-Za-z0-9]{6}$/;
        const ttNumbers = document.querySelector('#trackandtrace__searchinput').value

        let hasCardMatch = false

        for (let ttNumber of ttNumbers.split(/[\s,]+/)) {
            if (bnCardRegex.test(ttNumber.trim())) {
                hasCardMatch = true;
            }
        }

        if (hasCardMatch) {
            window.dataLayer.push({
                'event': 'suche_sendungsverfolgung',
                'track_id': 'Track-ID BN-Karte'
            });
        }
    }

    checkBnCardCode();

    if (document.querySelector('form.flexforms-form')) {
        document.querySelectorAll('form.flexforms-form').forEach((form) => {
            form.addEventListener('submit', (e) => {
                // get form type
                var formClasses = form.getAttribute('class').split(" ");
                var formType = false
                var formTypeMap = {
                    'businesscontactshoplp': 'ps-partner-werden-LPs-D',
                    'businesscontactlp': 'geschaeftskunde-werden-LPs-D',
                    'businesscontactlpdropdown': 'geschaeftskunde-werden-LPs-D',
                    'businesscontactconfigurator': 'geschaeftskunde-werden-kurz-konfigurator',
                    'businesscontactshort': 'geschaeftskunde-werden-kurz',
                    'businesscontactvad': 'geschaeftskunde-werden-VAD',
                    'businesscontactkam': 'geschaeftskunde-werden-KAM',
                    'businesscontactts': 'geschaeftskunde-werden-TS',
                    'businesscontactexpress': 'geschaeftskunde-werden-express',
                    'dateslotbooking': 'terminbuchungsformular',
                    'businesscontactlpdropdownwithstreet': 'geschaeftskunde-werden-LPs-D-strasse',
                    'businesscontact': 'geschaeftskunde-werden',
                    'servicecontact': 'kontaktformular-pk',
                    'servicecontactb2b': 'kontaktformular-gk',
                    'permanentdropoff': 'abstellgenehmigung',
                    'shopwish': 'wunsch-paketshop',
                    'zalandoretoure': 'zalando-retoure',
                    'shopapplication': 'ps-partner-werden',
                    'shopapplicationshort': 'ps-partner-werden',
                    'shopapplicationdpd': 'formular_ps-partner_werden-dpd',
                    'techpartner': 'technologiepartner-werden',
                    'joblead': 'pm-werden',
                    'exitintent': 'geschaeftskunde-werden-LPs-D-exit-intent-layer',
                    'psexitintent': 'ps-partner-werden-LPs-D-exit-intent-layer',
                    'pstationexitintent': 'paktetstation-partner-werden-LPs-D-exit-intent-layer',
                    'psexitintentsuccess': 'ps-partner-werden-upselling-layer',
                    'callback': 'rueckrufbitte',
                    'easyconnect': 'easyconnect',
                    'returnablelp': 'mehrweg',
                    'fulfillment': 'fulfillmentkunde-werden',
                    'shopappregistration': 'ps-partner-werden-self-service-tool-registrierung',
                    'transportpartner': 'transportpartner-werden',
                    'supplier': 'lieferant-werden',
                    'driverapplication': 'fahrer-werden',
                    'parcelstationapplication': 'paktetstation-partner-werden',
                    'psexitintentdpdautomode': 'paketshop-partner-werden-dpd-partnerschaft',
                    'partnersystem': 'partnersystem'
                }

                for (let i = 0; i < formClasses.length; i++) {
                    if (formClasses[i].indexOf('formtype-') === -1) {
                        continue;
                    }

                    formType = formClasses[i].split('-')[1];
                }

                if (!formType) {
                    return;
                }

                e.preventDefault()

                if (!formTypeMap.hasOwnProperty(formType)) {
                    return;
                }

                let formLabel = formTypeMap[formType]
                let bodyClasses = document.querySelector('body').classList

                if (formTypeMap[formType] === 'geschaeftskunde-werden-LPs-D' && bodyClasses.contains('landingpage-m')) {
                    formLabel = 'geschaeftskunde-werden-LPs-M'
                }

                if (formTypeMap[formType] === 'ps-partner-werden-LPs-D' && bodyClasses.contains('landingpage-m')) {
                    formLabel = 'ps-partner-werden-LPs-M'
                }

                if ((formType === 'exitintent' || formType === 'psexitintent') && bodyClasses.contains('become2bcustomer')) {
                    formLabel = 'geschaeftskunde-werden-D-exit-intent-layer'
                }

                if ((formType === 'exitintent' || formType === 'psexitintent') && bodyClasses.contains('becomeparcelshoppage')) {
                    formLabel = 'ps-partner-werden-D-exit-intent-layer'
                }

                if ((formType === 'exitintent' || formType === 'psexitintent') && bodyClasses.contains('becomeparcelshoplp')) {
                    formLabel = 'ps-partner-werden-LPs-D-exit-intent-layer'
                }

                if ((formType === 'exitintent' || formType === 'psexitintent') && bodyClasses.contains('becomeparcelshoplp')) {
                    formLabel = 'ps-partner-werden-LPs-D-exit-intent-layer'
                }

                if ((formType === 'easyconnect') && bodyClasses.contains('easyconnectlp')) {
                    formLabel = 'easyconnect-LPs'
                }

                if (bodyClasses.contains('landingpage-akquise-m1')) {
                    formLabel = 'geschaeftskunde-werden-LPs-M1-akquise'
                }

                if (bodyClasses.contains('landingpage-akquise-m2')) {
                    formLabel = 'geschaeftskunde-werden-LPs-M2-akquise'
                }

                if (bodyClasses.contains('landingpage-akquise-d')) {
                    formLabel = 'geschaeftskunde-werden-LPs-D-akquise'
                }

                if (bodyClasses.contains('industrypage-mode')) {
                    formLabel = 'geschaeftskunde-werden-mode'
                }

                if (bodyClasses.contains('landingpage-march23')) {
                    formLabel = 'geschaeftskunde-werden-LPs-D-endkundenkampagne'
                }

                if (bodyClasses.contains('customerportalpage')) {
                    formLabel = 'geschaeftskunde-werden-cup'
                }

                if (bodyClasses.contains('industrysolutionpage')) {
                    formLabel = 'geschaeftskunde-werden-branchenseiten'
                }

                // Determine count
                let parcelCount = null;

                if (form.querySelector('input[name=parcels]')) {
                    parcelCount = parseInt(form.querySelector('input[name=parcels]').value)
                } else if (form.querySelector('select[name=parcels],select[name=parcels_express]')) {
                    parcelCount = form.querySelector('select[name=parcels],select[name=parcels_express]').value
                } else if (form.querySelector('input[name=parcels_international]')) {
                    parcelCount = parseInt(form.querySelector('input[name=parcels_international]').value) + parseInt(form.querySelector('input[name=parcels_international]').value)
                }

                if (parcelCount && typeof parcelCount === 'number') {
                    if (parcelCount <= 20) {
                        parcelCount = '1-20'
                    } else if (parcelCount <= 300) {
                        parcelCount = '21-300'
                    } else if (parcelCount <= 620) {
                        parcelCount = '301-620'
                    } else {
                        parcelCount = '> 620'
                    }
                }

                let formSubmitted = false

                // Fallbacktimeout if gtm was blocked
                const fallbackTimeout = window.setTimeout(() => {
                    if (formSubmitted) {
                        return
                    }

                    form.submit()
                    formSubmitted = true
                }, 2500)

                const eventPayload = {
                    'event': 'formular_abgeschickt',
                    'formular': formLabel,
                    'eventCallback' : function () {
                        window.clearTimeout(fallbackTimeout)

                        if (formSubmitted) {
                            return
                        }

                        form.submit()
                        formSubmitted = true
                    },
                    'eventTimeout' : 2000
                }

                if (parcelCount) {
                    eventPayload.parcelCount = parcelCount
                }

                if (form.querySelector('input[type=email]')) {
                    eventPayload.user_email = form.querySelector('input[type=email]').value
                }

                window.dataLayer.push(eventPayload);
            })
        })
    }

    // Look for system message container and form to trigger success message
    if (document.getElementById('system-message-container') && document.querySelector('form.flexforms-form:not(.formtype-callback)')) {

    }

    // Search result page with no results - SWP 107
    if (document.querySelector('#search-result-empty')) {
        window.dataLayer.push({
            'event': 'suche_null_ergebnisse'
        });
    }

    // Search result page with results - SWP 248
    if (document.querySelectorAll('ol#search-result-list li').length && !document.querySelector('#search-result-empty')) {
        window.dataLayer.push({
            'event': 'suche_ergebnisse'
        });
    }

    // Now a special case: the callback form – first, trigger a virtual PI when the form is opened
    document.querySelectorAll('*[href="#modal-call-back-form"]').forEach((link) => {
        link.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'virtual_pageview',
                'virtual_page_path': '/geschaeftlich-versenden/rueckruf-anfordern',
                'virtual_page_title': 'Rückruf anfordern'
            });
        })
    })


    // If a new parcel or parcelshop search is submitted
    window.addEventListener('urlChange', function (e) {
        if (document.querySelector('#trackandtrace__searchinput')) {
            if (document.querySelector('html').getAttribute('lang') === 'de-de') {
                window.dataLayer.push({
                    'event': 'virtual_pageview',
                    'virtual_page_path': '/sendungsverfolgung?trackingNumber=xxxxxx',
                    'virtual_page_title': 'Sendungsverfolgung: Pakete immer im Blick | GLS Paketdienst'
                });

            } else {
                window.dataLayer.push({
                    'event': 'virtual_pageview',
                    'virtual_page_path': '/en/parcel-tracking?trackingNumber=xxxxxxx',
                    'virtual_page_title': 'Parcel tracking: Easy status overview | GLS parcel service'
                });
            }

            window.checkBnCardCode();
        }

        if (document.querySelector('.shopfinder_container')) {
            window.dataLayer.push({
                'event': 'virtual_pageview',
                'virtual_page_path': window.location.pathname.replace(new RegExp(['/$']), '') + window.location.search,
                'virtual_page_title': 'Shop Suche'
            });
        }
    })

    // ASG form tracking
    document.querySelectorAll('a.btn[href="/pakete-empfangen/einmalige-abstellgenehmigung"], a.btn[href="/en/receiving-parcels/one-time-drop-off-permission"]').forEach((link) => {
        link.addEventListener('click', () => {
            e.preventDefault();

            window.dataLayer.push({
                'event': 'button_geklickt',
                'button': 'asg-einmalige-asg'
            });

            window.setTimeout(() => {
                e.target.getAttribute('href')
            }, 1500)
        })
    })

    document.querySelectorAll('a.btn[href="/pakete-empfangen/dauerhafte-abstellgenehmigung"], a.btn[href="/en/receiving-parcels/permanent-drop-off-permission"]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            window.dataLayer.push({
                'event': 'button_geklickt',
                'button': 'asg-dauerhafte-asg'
            });

            window.setTimeout(() => {
                e.target.getAttribute('href')
            }, 1500)
        })
    })

    document.querySelectorAll("a.download_item[href*='/downloads/']").forEach((link) => {
        link.addEventListener('click', (e) => {
            let downloadAnchor = link.parentNode.querySelector('.anchoroffset')

            if (!downloadAnchor) {
                return;
            }

            let lang = (window.location.pathname.indexOf('/en') === 0) ? 'en' : 'de';

            window.dataLayer.push({
                'event': 'download',
                'file': downloadAnchor.getAttribute('id') + '-' + lang
            });
        })
    })

    // Landingpage slider and accordion clicks
    document.querySelectorAll('body.landingpage #switch-slider .advantage_item a[data-slide-to], body.landingpage .ce_carousel_news_slider .carousel-control-prev, body.landingpage .ce_carousel_news_slider .carousel-control-next, body.landingpage .ce_carousel_news_slider .carousel-indicators li').forEach((control) => {
        control.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'slider_geklickt',
                'formular': 'geschaeftskunde-werden-LPs-slider-D'
            });
        })
    })

    document.querySelectorAll('body.landingpage.landingpage-m .accordion--narrowfit .trigger').forEach((control) => {
        control.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'akkordeon_aufgeklappt',
                'button': 'geschaeftskunde-werden-LPs-akkordeon-M'
            });
        })
    })

    // Leadpage video play event - SWP 213
    document.querySelectorAll('body.landingpage.landingpage-akquise-m1 video, body.landingpage.landingpage-akquise-m2 video, body.landingpage.landingpage-akquise-d video').forEach((video) => {
        video.addEventListener('play', () => {
            var el = 'export-video-lps-D'

            if (document.querySelector('body.landingpage.landingpage-akquise-m1')) {
                el = 'export-video-lps-M1'
            }

            if (document.querySelector('body.landingpage.landingpage-akquise-m2')) {
                el = 'export-video-lps-M2'
            }

            window.dataLayer.push({
                'event': 'video_abgespielt',
                'video': el
            });
        })
    })

    if(document.querySelector('.container_seeking-package--homehero form')) {
        document.querySelector('.container_seeking-package--homehero form').addEventListener('submit', (e) => {
            e.preventDefault()

            window.dataLayer.push({
                'event': 'button_geklickt',
                'button': 'hp-sendungsverfolgung'
            });

            window.setTimeout(() => {
                e.target.submit()
            }, 1500)
        })
    }

    // SWP-314
    window.addEventListener('parcelsRendered',  () => {
        document.querySelectorAll('#trackandtrace__contentcontainer .trigger-status').forEach((statusElement) => {
            let triggerClasses = statusElement.classList
            let status, el

            for (let triggerClass of triggerClasses) {
                if (triggerClass.includes("trigger-status--")) {
                    status = triggerClass.split("--")[1]
                }
            }

            switch(status) {
                case "preadvice":
                    el = "sendungsverfolgung-daten-uebermittelt"
                    break;

                case "intransit":
                    el = "sendungsverfolgung-unterwegs"
                    break;

                case "indelivery":
                    el = "sendungsverfolgung-in-zustellung"
                    break;

                case "inwarehouse":
                    el = "sendungsverfolgung-im-zielpaketzentrum"
                    break;

                case "delivered":
                    el = "sendungsverfolgung-zugestellt-normal"
                    break;

                case "deliveredps":
                    el = "sendungsverfolgung-zugestellt-in-PS"
                    break;

                case "canceled":
                    el = "sendungsverfolgung-storniert"
                    break;

                case "notdelivered":
                    el = "sendungsverfolgung-nicht-zugestellt"
                    break;

                case "plannedpickup":
                    el = "sendungsverfolgung-geplante-abholung"
                    break;

                case "inpickup":
                    el = "sendungsverfolgung-in-abholung"
                    break;

                case "notpickedup":
                    el = "sendungsverfolgung-nicht-abgeholt"
                    break;

                case "final":
                    el = "sendungsverfolgung-beendete-pakethistorie"
                    break;

                case "missedfirstattempt":
                    el = "sendungsverfolgung-nicht-zugestellt-1.-zustellversuch"
                    break;

                case "notdeliveredpsreroute":
                    el = "sendungsverfolgung-nicht-zugestellt-AZ-paketshop"
                    break;

                case "notdelivereddepotreroute":
                    el = "sendungsverfolgung-nicht-zugestellt-AZ-depot"
                    break;

                case "missedsecondpickupattempt":
                    el = "sendungsverfolgung-nicht-abgeholt-2.-abholversuch"
                    break;

                case "missedfirstpickupattempt":
                    el = "sendungsverfolgung-nicht-abgeholt-1.-abholversuch"
                    break;

                case "deliveredneighbor":
                    el = "sendungsverfolgung-zugestellt-AZ-nachbar"
                    break;
            }

            if (!el) {
                return
            }

            window.dataLayer.push({
                'event': 'paketstatus',
                'element': el
            });
        })


        // NPS box visibile tracking, SWP-237
        if (typeof(IntersectionObserver) === 'function') {
            // Register IntersectionObserver
            let npsObserver = new IntersectionObserver((entries) => {
                for (let i = 0; i < entries.length; i++) {
                    // Add 'active' class if observation target is inside viewport
                    if (entries[i].intersectionRatio > 0 && !entries[i].target.classList.contains('nps-event-dispatched')) {
                        entries[i].target.classList.add('nps-event-dispatched');

                        window.dataLayer.push({
                            'event': 'element_sichtbarkeit',
                            'element': 'sendungsverfolgung-nps-box-angezeigt'
                        });
                    }
                }
            })

            // Declares what to observe, and observes its properties.
            document.querySelectorAll('.tracking--npsbox').forEach((npsBox) => {
                npsObserver.observe(npsBox)
            })
        }

        // RTT box visibile tracking, SWP-255
        if (typeof(IntersectionObserver) === 'function') {
            // Register IntersectionObserver
            let rttObserver = new IntersectionObserver((entries) => {
                for (let i = 0; i < entries.length; i++) {
                    // Add 'active' class if observation target is inside viewport
                    if (entries[i].intersectionRatio > 0 && !entries[i].target.classList.contains('rtt-event-dispatched')) {
                        entries[i].target.classList.add('rtt-event-dispatched');

                        window.dataLayer.push({
                            'event': 'element_sichtbarkeit',
                            'element': 'sendungsverfolgung-rtt-button-angezeigt'
                        });
                    }
                }
            })

            // Declares what to observe, and observes its properties.
            document.querySelectorAll('a[href^="https://gls-rtt.com"]').forEach((rttLink) => {
                rttObserver.observe(rttLink)
            })
        }

        // T&T signature button tracking, SWP-295
        if (typeof(IntersectionObserver) === 'function') {
            // Register IntersectionObserver
            let ttSignatureButtonObserver = new IntersectionObserver(function(entries) {
                for (let i = 0; i < entries.length; i++) {
                    // Add 'active' class if observation target is inside viewport
                    if (entries[i].intersectionRatio > 0 && !entries[i].target.classList.contains('tt-signature-event-dispatched')) {
                        entries[i].target.classList.add('tt-signature-event-dispatched');

                        window.dataLayer.push({
                            'event': 'element_sichtbarkeit',
                            'element': 'sendungsverfolgung-unterschrift-angezeigt'
                        });
                    }
                }
            })

            // Declares what to observe, and observes its properties.
            document.querySelectorAll('button.tntsignaturebutton').forEach((tntButton) => {
                ttSignatureButtonObserver.observe(tntButton)
            })
        }

        // reroutev3 box visibile tracking, SWP-418
        if (typeof(IntersectionObserver) === 'function') {
            // Register IntersectionObserver
            let baseRerouteboxObserver = new IntersectionObserver(function(entries) {
                for (let i = 0; i < entries.length; i++) {
                    // Add 'active' class if observation target is inside viewport
                    if (entries[i].intersectionRatio > 0 && !entries[i].target.classList.contains('reroutebasebox-event-dispatched')) {
                        entries[i].target.classList.add('reroutebasebox-event-dispatched');

                        window.dataLayer.push({
                            'event': 'element_sichtbarkeit',
                            'element': 'sendungsverfolgung-box-umverfuegung-group-sichtbar'
                        });
                    }
                }
            })

            // Declares what to observe, and observes its properties.
            document.querySelectorAll('.tracking--reroutebox:not(.tracking--reroutebox--v3)').forEach((baseRerouteBox) => {
                baseRerouteboxObserver.observe(baseRerouteBox)
            })
        }

        // base reroute box visibile tracking, SWP-619
        if (typeof(IntersectionObserver) === 'function') {
            // Register IntersectionObserver
            let rerouteboxObserver = new IntersectionObserver(function(entries) {
                for (let i = 0; i < entries.length; i++) {
                    // Add 'active' class if observation target is inside viewport
                    if (entries[i].intersectionRatio > 0 && !entries[i].target.classList.contains('pushbox-event-dispatched')) {
                        entries[i].target.classList.add('pushbox-event-dispatched');

                        window.dataLayer.push({
                            'event': 'element_sichtbarkeit',
                            'element': 'sendungsverfolgung-box-umverfuegung-gruen-group-sichtbar'
                        });
                    }
                }
            })

            // Declares what to observe, and observes its properties.
            document.querySelectorAll('.tracking--reroutebox--v3').forEach((rerouteBox) => {
                rerouteboxObserver.observe(rerouteBox)
            })
        }

        // greendelivery info display, SWP-616
        if (typeof(IntersectionObserver) === 'function') {
            // Register IntersectionObserver
            let greendeliveryNoteObserver = new IntersectionObserver(function(entries) {
                for (let i = 0; i < entries.length; i++) {
                    // Add 'active' class if observation target is inside viewport
                    if (entries[i].intersectionRatio > 0 && !entries[i].target.classList.contains('greendeliverynote-event-dispatched')) {
                        entries[i].target.classList.add('greendeliverynote-event-dispatched');

                        window.dataLayer.push({
                            'event': 'element_sichtbarkeit',
                            'element': 'sendungsverfolgung-efahrzeug-angezeigt'
                        });
                    }
                }
            })

            // Declares what to observe, and observes its properties.
            document.querySelectorAll('.tracking--greendelivery, .tracking--statustext--hasgreendelivery').forEach((greendeliveryNote) => {
                greendeliveryNoteObserver.observe(greendeliveryNote)
            })
        }

        // SWP-623
        document.querySelectorAll('#trackandtrace__contentcontainer a[href^="https://gls-rtt.com"], #trackandtrace__contentcontainer *[id^="rttbox-"] .btn').forEach((btn) => {
          btn.addEventListener('click', (e) => {
              window.dataLayer.push({
                  'event': 'button_geklickt',
                  'button': 'sendungsverfolgung-rtt'
              });
          })
        })

        // SWP-295
        if (document.querySelector('#trackandtrace__contentcontainer form.tntsignatureform')) {
            document.querySelector('#trackandtrace__contentcontainer form.tntsignatureform').addEventListener('submit', (e) => {
                window.dataLayer.push({
                    'event': 'button_geklickt',
                    'button': 'sendungsverfolgung-unterschrift-anzeigen'
                });
            })
        }

        // SWP-418
        document.querySelectorAll('#trackandtrace__contentcontainer .tracking--reroutebox--v3 .btn').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                window.dataLayer.push({
                    'event': 'button_geklickt',
                    'button': 'sendungsverfolgung-umverfuegung-gruen-group'
                });

                window.setTimeout(() => {
                    window.location = e.target.getAttribute('href')
                },1500)
            })
        })
    })

    // SWP-335
    document.querySelectorAll('body.landingpage-mode a[href="/geschaeftlich-versenden/geschaeftskunde-werden"]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            window.dataLayer.push({
                'event': 'button_geklickt',
                'button': 'GK-werden-content-body'
            });

            window.setTimeout(() => {
                window.location = link.getAttribute('href')
            },1500)
        })
    })

    // SWP-350
    window.addEventListener('exitIntentShown', function () {
        window.dataLayer.push({
            'event': 'element_sichtbarkeit',
            'element': 'gk-werden-LPs-D-exit-intent-layer-angezeigt'
        });
    })

    // SWP-751
    window.addEventListener('partnerFinderSearchTriggered', function () {
        const count = document.querySelectorAll('.partnerfinder--desktop .partnerfinder__items-item:not([style*=none])').length

        window.dataLayer.push({
            'event': (count > 0) ? 'partnerfinder_ergebnisse' : 'partnerfinder_keine_ergebnisse',
            'track_id': document.querySelector('#partnersearch').value
        })
    })

    document.querySelectorAll('body.landingpage-mode a[href="/geschaeftlich-versenden/geschaeftskunde-werden"]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            window.dataLayer.push({
                'event': 'button_geklickt',
                'button': 'GKForm-registration-gls-one'
            });

            window.setTimeout(() => {
                window.location = link.getAttribute('href')
            }, 1500)
        })
    })

    // Adwords tracking case 2.5
    if(document.querySelector('#pricing-country-select')) {
        document.querySelector('#pricing-country-select').addEventListener('change', () => {
            window.dataLayer.push({
                'event': 'laenderauswahl',
                'bereich': 'preisuebersicht'
            });
        })
    }

    // Adwords  ads tracking case "parcel search"
    window.addEventListener('parcelshopSearchStart', function (e) {
        window.dataLayer.push({
            'event': 'paketshop_suche'
        });
    });

    // Adwords tracking case "Click on "become partner shop" button"
    document.querySelectorAll('a.btn[data-tracktype="becomeglsshoppartner"]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            window.dataLayer.push({
                'event': 'link_geklickt',
                'link': 'paketshop-partner-werden'
            });

            window.setTimeout(() => {
                window.location = e.target.getAttribute('href')
            }, 2000)
        })
    })

    // GLS One Registration, SWP-273
    document.querySelectorAll('a.btn[href="https://www.gls-one.de/de/registration?utm_source=gls-pakete&utm_campaign=ASG"], a.btn[href="https://www.gls-one.de/en/registration?utm_source=gls-pakete&utm_campaign=ASG"]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            window.dataLayer.push({
                'event': 'button_geklickt',
                'button': 'registration-gls-one'
            });

            window.setTimeout(() => {
                window.location = e.target.getAttribute('href')
            }, 2000)
        })
    })

    // SWP 1022
    if (document.querySelector('#mod-productconfigurator-otherindustrybutton')) {
        document.querySelector('#mod-productconfigurator-otherindustrybutton').addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'paketkonf_weiter_branche',
                'button': document.querySelector('#mod-productconfigurator-otherindustrytext').value
            });
        })
    }

    //SWP 1024
    document.querySelectorAll('*[data-clicktrack-event]').forEach((element) => {
        element.addEventListener('click', (e) => {
            const linkTarget = e.currentTarget.getAttribute('href');

            if (!linkTarget || linkTarget.includes('mailto:')) {
                return
            }

            e.preventDefault();

            window.dataLayer.push({
                'event': e.currentTarget.getAttribute('data-clicktrack-event'),
                'button': e.currentTarget.getAttribute('data-clicktrack-button')
            });

            window.setTimeout(() => {
                window.location = linkTarget
            }, 2000)
        })
    })
}) ()
